import analytics from "./app/analytics"
import trackActions from "./app/trackActions"
import history from "./app/history"
import url from "./app/url"
import recentInstruments from "./app/recentInstruments"
import setLocalStoreValues from "./localStore/set"
import globalSagas from "model/sagas"
import modulesSagas from "modules/sagas"
import { saga as alphaTheoryShareSaga } from "components/alpha-theory-share/model"

export default [
  analytics,
  trackActions,
  setLocalStoreValues,
  history,
  url,
  recentInstruments,
  ...globalSagas,
  ...modulesSagas,
  alphaTheoryShareSaga,
]
